/* eslint-disable @typescript-eslint/naming-convention */
import { useOutletContext } from "react-router-dom"
import { useSignal } from "@preact/signals-react"

import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import Table from 'react-bootstrap/Table'

import SelectParentBusinessEntityLeaf from "../../components/SelectParentBusinessEntityLeaf.jsx"
import Loadable from "../../../../components/Loadable.jsx"
import LoadingAnimation from "../../../../components/LoadingAnimation.jsx"

import { businessEntitiesLoadedSignal, businessEntitiesErrorSignal } from '../../../../state/signals/businessEntitySignals.js'

const SelectParentModal = function ({ showSignal, rootBusinessEntity, parentBusinessEntityIdSignal, previousModalShowSignal = null }) {

	const { user, config, accessToken, userPermissions, userPermissionsSummary, accordionData } = useOutletContext()

	const tempSelectedBusinessEntityIdSignal = useSignal(parentBusinessEntityIdSignal.value)

	const cancelSelectParent = function () {
		showSignal.value = false
		previousModalShowSignal.value = true
		tempSelectedBusinessEntityIdSignal.value = parentBusinessEntityIdSignal.value
	}

	const confirmSelectParent = () => {
		showSignal.value = false
		previousModalShowSignal.value = true
		parentBusinessEntityIdSignal.value = tempSelectedBusinessEntityIdSignal.value
	}

	return (
		<Modal onHide={cancelSelectParent} show={showSignal.value} size="xl">
			<Modal.Header closeButton>
				<Modal.Title>Select Parent Business Entity</Modal.Title>
			</Modal.Header>
			<Modal.Body className='modal-body modal-table'>
				<Table id='groupParentOrg'>
					<thead></thead>
					<tbody style={{ display: "block", maxHeight: "calc(100vh - 250px)", overflowY: "auto" }}>{
						businessEntitiesLoadedSignal.value ? (
							<SelectParentBusinessEntityLeaf
								businessEntity={rootBusinessEntity}
								selectedBusinessEntityIdSignal={tempSelectedBusinessEntityIdSignal}
								depth={0}
							/>
						) : (<tr><td colSpan={2}><LoadingAnimation /></td></tr>)
					}</tbody>
				</Table>
			</Modal.Body>
			<Modal.Footer>
				<Button onClick={cancelSelectParent}>Cancel</Button>
				<Loadable loadedSignals={[businessEntitiesLoadedSignal]} errorSignals={[businessEntitiesErrorSignal]}>
					<Button onClick={confirmSelectParent}>Apply</Button>
				</Loadable>
			</Modal.Footer>
		</Modal>
	)
}
export default SelectParentModal